<template>
  <div class="GoodsTable">
    <el-dialog
      :title="searchData.title"
      width="922px"
      append-to-body
      :visible.sync="visible"
      @close="clearData"
      :show="show"
      :close-on-click-modal="false"
    >
      <div
        class="content_box"
        ref="key_content"
        id="key_content"
        tabindex="1"
        @keydown.up="upkey($event)"
        @keydown.down="downkey($event)"
        @keydown.enter="enterkey($event)"
      >
        <div class="content_top">
          <el-input
            ref="input"
            v-model="searchText"
            size="mini"
            placeholder="输入名称/编号/助记码"
            class="search_input"
            @keydown.up.native="upkey($event)"
            @keydown.down.native="downkey($event)"
            @keydown.enter.native="enterkey($event)"
          ></el-input>
          <!-- <el-checkbox v-model="showLeve" style="margin-left:10px;" @change="checkChange">显示层级结构</el-checkbox> -->
          <el-button type="warning" size="mini" class="search_btn" @click="searchClick">查询</el-button>
        </div>
        <div class="content_infor_box">
          <div class="tree_sty" id="box">
            <Tree :treeData="treeData" @clickTree="clickTree" ref="treecomponent" />
          </div>
          <vxe-table
            ref="xTable"
            class="right"
            resizable
            size="small"
            border
            highlight-hover-row
            highlight-current-row
            :keyboard-config="{isArrow:true}"
            :auto-resize="true"
            height="auto"
            :data="tableData"
            show-overflow
            show-header-overflow
            @current-change="currentChangeEvent"
            @select-change="selectChangeEvent"
            @select-all="selectAllEvent"
            @cell-dblclick="dbclick"
          >
            <vxe-table-column type="checkbox" align="center" fixed="left" width="60"></vxe-table-column>
            <vxe-table-column width="50" fixed="left" title="类型" align="center">
              <template v-slot="{row}">
                <i
                  :class="row.IsDir?'el-icon-folder':'el-icon-tickets'"
                  style="color:#e9cb70;font-size:18px"
                ></i>
              </template>
            </vxe-table-column>
            <template v-for="(item,index) in tableHeadData">
              <vxe-table-column
                :field="item.Key"
                :title="item.Label"
                width="150"
                align="center"
                fixed="left"
                v-if="item.Key=='FullName'"
                :key="index"
              ></vxe-table-column>
              <vxe-table-column
                :field="item.Key"
                :title="item.Label"
                width="150"
                align="center"
                v-else-if="item.Key=='BaseCode'"
                :key="index"
              ></vxe-table-column>
              <vxe-table-column
                :field="item.Key"
                :title="item.Label"
                width="150"
                align="center"
                v-else
                :key="index"
              ></vxe-table-column>
            </template>
          </vxe-table>
        </div>
        <!-- 分页 -->
        <div class="content_btn_box">
          <el-pagination
            style="display: flex;  justify-content: space-between;justify-content: center; "
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20,50,100]"
            :page-size="pagesize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
          <div style="width: 214px;display: flex;justify-content: flex-end;">
            <el-button type="primary" size="mini" style="display:block" @click="saveGoods">确定</el-button>
            <el-button style="display:block" size="mini" @click="$emit('update:show', false)">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>  

<script>
// 引入样板数组
import dataConfig from "@/utils/data.js";
// 工具库
import tool from "@/utils/tool"; //本地缓存存取
import { locale } from "moment";

export default {
  data() {
    return {
      multipleSelection: [], // 多选
      // 字段值
      searchText: this.textname, //"",   //收索内容
      treeData: [], //树状图数据
      tableData: [], //table表格数据
      tableHeadData: this.configData, //表格表头配置字段
      searchData: {
        // 传入下一个弹出框的字段，包含标题，树状图url，表格url，过滤url
        title: "商品",
        url1: "/index/Goods/getlist",
        url2: "/index/Goods/getall",
        url3: "/index/Goods/search",
        classify: "Goods",
      },
      // 状态值
      visible: this.show, //是否显示选择弹出框
      showLeve: true, //是否显示层级
      rowIndex: 0, //默认表格索引
      ParentNo: 0,
      // 分页
      currentPage: 1, //当前页码
      total: 0, //总页数
      pagesize: 10, //每页显示数量
      no: 0,
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    configData: {
      type: Array,
      default: () => {
        return [
          { Label: "商品名称", Key: "FullName" },
          { Label: "商品编号", Key: "BaseCode" },
          { Label: "可用库存", Key: "AQty" },
          { Label: "单位", Key: "UnitName" },
          { Label: "规格", Key: "Standards" },
          { Label: "型号", Key: "Model" },
          { Label: "产地", Key: "ProArea" },
        ];
      },
    }, //配置项数据
    // searchData: [Object]
  },
  watch: {
    show() {
      this.visible = this.show;
      this.no = Math.random(1);
      if (this.visible) {
        // this.switchInit(this.showLeve);
        this.$nextTick(() => {
          this.$refs.key_content.focus();
          // this.$refs.input.focus();
          this.$refs.xTable.clearSelection();
        });
        this.multipleSelection = [];
      } else {
        this.tableData = [];
      }
    },
    // 默认选中表格第一行
    tableData: {
      handler: function (newVal, oldVal) {
        let that = this;
        if (that.visible && newVal && newVal.length > 0) {
          that.rowIndex = 0; //重置索引
          that.$nextTick(() => {
            that.$refs.xTable.setCurrentRow(that.tableData[0]);
          });
        }
      },
      deep: true, //对象内部的属性监听，也叫深度监听
    },
    visible: {
      handler(newVal, oldVal) {
        if (newVal) {
          this.InitTree();
          this.searchText = this.$attrs.textname;
          if (this.searchText != "") {
            this.searchClicks(this.$attrs.textname);
          } else {
            this.InitTable();
          }
        }
        if (!newVal) {
          this.searchText = "";
          this.currentPage = 1;
        }
      },
      deep: true, //对象内部的属性监听，也叫深度监听
    },
  },
  methods: {
    searchClicks(newVal) {
      let invid;
      if (this.$attrs.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.$attrs.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Keywords: newVal,
        pagesize: this.pagesize,
        pagenum: this.currentPage,
        KtypeId: this.$attrs.warehouseVal1.KtypeId,
        KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        pagenum: this.currentPage,
        Stoped: this.$attrs.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        BuySale: this.$attrs.pargam.BuySale,
        BtypeId: this.$attrs.customerVal1.KtypeId,

        InvId: invid, // 盘点单 InvID没有投就传l
        // type: type //0显示层级结构 1不显示
      };
      this.request
        .post(this.searchData.url3, { jparams: JSON.stringify(params) })
        .then((res) => {
          // 接收后端发送回来的数据
          // setTimeout(() => {
          this.total = res.count;
          if (this.$attrs.pargam.Model != "TakeStock") {
            this.tableData = res.data;
          } else {
            res.data.map((item) => {
              item.AQty = item.Qty;
              item.Qty = 0;
            });
            this.tableData = res.data;
          }
          // }, 10);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dbclick(row) {
      let _this = this;
      // let a = Math.ceil(Math.random() * 100);
      // let a = Math.random(1);
      row.row._XID = `row_${_this.no}`;
      setTimeout(() => {
        // let a = this.randomNum(0, new Date().valueOf());
        _this.$emit("chooseBack", [row.row]);
        _this.$emit("update:show", false);
      }, 300);
    },
    selectChangeEvent({ selection }) {
      this.multipleSelection = selection;
    },
    selectAllEvent({ selection }) {
      this.multipleSelection = selection;
    },
    saveGoods() {
      setTimeout(() => {
        this.$emit("chooseBack", this.multipleSelection);
        this.$emit("update:show", false);
      }, 300);
    },
    // 请求树状图数据
    InitTree() {
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        pagesize: this.pagesize,
        pagenum: this.currentPage,
        Stoped: this.$attrs.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        style: this.$attrs.pargam.style, //1-供应商,0-客户,2-客户供应商都出来
        KtypeId: this.$attrs.warehouseVal1.KtypeId, //仓库ID
        Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
      };
      this.request
        .post(this.searchData.url1, { jparams: JSON.stringify(params) })
        .then((res) => {
          // 接收后端发送回来的数据
          this.treeData = res.tree;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求table表格数据
    InitTable(typeId) {
      let invid;
      if (this.$attrs.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.$attrs.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        pagesize: this.pagesize,
        pagenum: this.currentPage,
        Stoped: 0, //是否启用
        KtypeId: this.$attrs.warehouseVal1.KtypeId,
        KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        ParentNo: this.ParentNo, //父集ID
        style: this.$attrs.pargam.style, //1-供应商,0-客户,2-客户供应商都出来
        Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        BuySale: this.$attrs.pargam.BuySale,
        BtypeId: this.$attrs.customerVal1.KtypeId,
        // user_id: tool.getLocal("userid"),
        // session_id: tool.getLocal("sessionid"),
        // pagesize: this.pagesize,
        // pagenum: this.currentPage,
        // KtypeId: this.$attrs.warehouseVal1.KtypeId, //仓库ID
        // type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        // Stoped: this.$attrs.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        // style: this.$attrs.pargam.style, //1-供应商,0-客户,2-客户供应商都出来
        // KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        // Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        InvId: invid, // 盘点单 InvID没有投就传l
      };
      this.request
        .post(this.searchData.url3, { jparams: JSON.stringify(params) })
        .then((res) => {
          // 接收后端发送回来的数据
          this.total = res.count;
          if (this.$attrs.pargam.Model != "TakeStock") {
            this.tableData = res.data;
          } else {
            res.data.map((item) => {
              item.AQty = item.Qty;
              item.Qty = 0;
            });
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 条件查询table数据
    QueryTable() {
      let invid;
      if (this.$attrs.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.$attrs.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        pagesize: this.pagesize,
        pagenum: this.currentPage,
        Stoped: 0, //是否启用
        KtypeId: this.$attrs.warehouseVal1.KtypeId,
        KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        ParentNo: this.ParentNo, //父集ID
        style: this.$attrs.pargam.style, //1-供应商,0-客户,2-客户供应商都出来
        Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        InvId: invid, // 盘点单 InvID没有投就传l
        BtypeId: this.$attrs.customerVal1.KtypeId,
        BuySale: this.$attrs.pargam.BuySale,
      };

      this.request
        .post(this.searchData.url3, { jparams: JSON.stringify(params) })
        .then((res) => {
          // 接收后端发送回来的数据
          this.total = res.count;
          if (this.$attrs.pargam.Model != "TakeStock") {
            this.tableData = res.data;
          } else {
            res.data.map((item) => {
              item.AQty = item.Qty;
              item.Qty = 0;
            });
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击收索按钮
    searchClick() {
      let invid;
      if (this.$attrs.pargam.InvId == undefined) {
        invid = 0;
      } else {
        invid = this.$attrs.pargam.InvId;
      }
      let params = {
        user_id: tool.getLocal("userid"),
        session_id: tool.getLocal("sessionid"),
        Keywords: this.searchText,
        pagesize: this.pagesize,
        pagenum: this.currentPage,
        KtypeId: this.$attrs.warehouseVal1.KtypeId,
        KFlag: this.$attrs.pargam.KFlag, //是否查询库存&价格信息 0不查询 1查询
        type: 1, //type=0查询所有一级数据  type=1查询所有末端数据
        Model: this.$attrs.pargam.Model, //是否补齐表单参数(填写对应表单信息)Area、Goods、Person、Sale、Buy、SaleOrder等
        Stoped: this.$attrs.pargam.Stoped, //是否数据的状态 0启用 1停用  不传两者都有
        BuySale: this.$attrs.pargam.BuySale,
        InvId: invid, // 盘点单 InvID没有投就传l
        BtypeId: this.$attrs.customerVal1.KtypeId,
        // type: type //0显示层级结构 1不显示
      };
      this.request
        .post(this.searchData.url3, { jparams: JSON.stringify(params) })
        .then((res) => {
          // 接收后端发送回来的数据
          this.total = res.count;
          if (this.$attrs.pargam.Model != "TakeStock") {
            this.tableData = res.data;
          } else {
            res.data.map((item) => {
              item.AQty = item.Qty;
              item.Qty = 0;
            });
            this.tableData = res.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 点击树状图节点
    clickTree(data) {
      this.ParentNo = data.id;
      this.currentPage = 1;
      this.QueryTable();
    },
    // 表格选中行改变时触发，row：当前行数据
    currentChangeEvent(row) {},

    // 当前页显示条数发生变化时
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pagesize = val;
      if (this.searchText != "") {
        this.searchClick();
      } else {
        if (this.ParentNo != 0) {
          this.QueryTable();
        } else {
          this.InitTable();
        }
      }
      // this.$nextTick( () =>{
      //     this.$refs.input.focus();
      // } )
    },
    // 当前页发生变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      if (this.searchText != "") {
        this.searchClick();
      } else {
        if (this.ParentNo != 0) {
          this.QueryTable();
        } else {
          this.InitTable();
        }
      }
      // this.$nextTick( () =>{
      //     this.$refs.input.focus();
      // } )
    },
    // 退出清除数据
    clearData() {
      // 退出前是数据初始化
      this.$emit("update:show", false);
    },
    // 按上键
    upkey(e) {
      if (this.rowIndex != 0) {
        this.rowIndex--;
      }
      this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
      this.$refs.xTable.scrollToRow(this.$refs.xTable.getCurrentRow());
    },
    // 按下键
    downkey(e) {
      let that = this;
      if (this.tableData && this.rowIndex + 1 < this.tableData.length) {
        this.rowIndex++;
      }
      that.$nextTick(() => {
        that.$refs.xTable.setCurrentRow(that.tableData[that.rowIndex]);
        that.$refs.xTable.scrollToRow(that.$refs.xTable.getCurrentRow());
      });
    },
    randomNum(minNum, maxNum) {
      switch (arguments.length) {
        case 1:
          return parseInt(Math.random() * minNum + 1, 10);
          break;
        case 2:
          return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
          break;
        default:
          return 0;
          break;
      }
    },
    // 按回车键
    enterkey(e) {
      // this.$refs.xTable.setCurrentRow(this.tableData[this.rowIndex]);
      // function randomNum(minNum, maxNum) {
      //   switch (arguments.length) {
      //     case 1:
      //       return parseInt(Math.random() * minNum + 1, 10);
      //       break;
      //     case 2:
      //       return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      //       break;
      //     default:
      //       return 0;
      //       break;
      //   }
      // }
      if (this.multipleSelection.length !== 0) {
        this.$nextTick(() => {
          let _this = this;
          setTimeout(() => {
            let a = this.randomNum(0, new Date().valueOf());
            _this.$refs.xTable.getCurrentRow()._XID = `row_${a}`;
            _this.$emit("chooseBack", this.multipleSelection);
            _this.$emit("update:show", false);
          }, 100);
        });
      } else {
        this.$nextTick(() => {
          let _this = this;
          setTimeout(() => {
            let a = this.randomNum(0, new Date().valueOf());
            _this.$refs.xTable.getCurrentRow()._XID = `row_${a}`;
            _this.$emit("chooseBack", [_this.$refs.xTable.getCurrentRow()]);
            _this.$emit("update:show", false);
          }, 100);
        });
      }
    },
  },
  // 创建生命周期钩子函数
  mounted() {
    // this.switchInit(this.showLeve);
    // this.$refs.xTable.clearSelection();
  },
};
</script>

<style lang="less">
.content_btn_box {
  display: -webkit-box !important;
  display: box !important;
  position: relative;
  -webkit-box-align: center;
  box-align: center;
}
#key_content:focus {
  outline: none;
  border: 0;
  border-color: red;
}
.el-dialog__header {
  background: rebeccapurple;
  padding: 10px 10px 0;
  .el-dialog__title {
    color: #fff;
    font-size: 14px;
  }
  .el-dialog__headerbtn {
    top: 10px;
    right: 10px;
    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }
  }
}
.el-dialog__body {
  padding: 10px 20px;
}
.content_box {
  .content_top {
    width: 100%;
    height: 40px;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    -webkit-box-align: center;
    box-align: center;
    .search_input {
      display: block;
      width: 202px;
      margin-right: 8px;
    }
  }
  .content_infor_box {
    width: 100%;
    height: 300px;
    display: -webkit-box !important;
    display: box !important;
    position: relative;
    .tree_sty {
      min-width: 200px;
      max-width: 890px;
      height: 300px;
    }
    .drage_box {
      width: 10px;
      height: 100%;
      cursor: e-resize !important;
    }
    .right {
      margin-left: 10px;
      height: 100%;
      position: relative;
      -webkit-box-flex: 1;
      box-flex: 1;
    }
  }
}
.el-tree {
  background: inherit;
}
//滚动条的宽度
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}
//滚动条的滑块
::-webkit-scrollbar-thumb {
  //   background-color: #a1a3a9;
  //   border-radius: 3px;
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #ccc;
}
:-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/GoodsTable/GoodsTable.vue